import axios, { type AxiosResponse, type AxiosError, type Method } from 'axios';

import { HTTP_REQUEST_HEADER_CSRF_PROTECTION } from 'src/utils';

import { ApiError } from './errors';

const getUrl = (path: string) => {
  try {
    new window.URL(path);
    return decodeURIComponent(path);
  } catch {
    return `${import.meta.env.VITE_SERVICE_DATA_CONNECTOR_API_URL}${decodeURIComponent(path)}`;
  }
};

axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common[HTTP_REQUEST_HEADER_CSRF_PROTECTION] = '1';

const executeApiCall = async (
  method: Method,
  path: string,
  data: object | null,
  params: object,
  signal?: AbortSignal
) => {
  const endpoint = getUrl(path);

  return axios(endpoint, {
    method,
    data,
    params,
    paramsSerializer: (params) =>
      Object.entries(params)
        .map(([key, value]) => `${key}=${value}`)
        .join('&'),
    withCredentials: true,
    signal,
  })
    .then(
      (response: AxiosResponse): Pick<AxiosResponse, 'data' | 'status'> => ({
        data: response?.data,
        status: response?.status,
      })
    )
    .catch((error: AxiosError) => ApiError.handleError(error));
};

export default {
  delete: (path: string, data: object = {}, params: object = {}, signal?: AbortSignal) =>
    executeApiCall('DELETE', path, data, params, signal),
  get: (path: string, params: object = {}, signal?: AbortSignal) =>
    executeApiCall('GET', path, null, params, signal),
  post: (path: string, data: object = {}, params: object = {}, signal?: AbortSignal) =>
    executeApiCall('POST', path, data, params, signal),
  patch: (path: string, data: object = {}, params: object = {}, signal?: AbortSignal) =>
    executeApiCall('PATCH', path, data, params, signal),
};
